import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import Vue3Signature from "vue3-signature";

import naiveUI from "naive-ui";

createApp(App)
  .use(router)
  .use(naiveUI)
  .use(Vue3Signature)
  //.component(NMessageProvider.name, NMessageProvider)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyAifGcMcgkaioETYENe1yugA0MpVslQNqk",
      libraries: "places",
      // language: 'de',
    },
  })
  .mount("#app");
